"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var rootButtonStyles = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
};
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: rootButtonStyles,
        button: __assign({ backgroundColor: 'unset', cursor: 'pointer', borderRadius: 4, border: 'none', outlineOffset: -1, '&:focus-within': {
                outline: "1px solid ".concat(theme_1.default.colors.primary),
            } }, rootButtonStyles),
        hoverElement: {
            borderRadius: 4,
        },
        enabled: {
            cursor: 'pointer',
            '.hoverable&:hover, .hoverable&:focus-within': {
                backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5),
            },
        },
        alertEnabled: {
            cursor: 'pointer',
            '.hoverable&:hover, .hoverable&:focus-within': {
                backgroundColor: theme_1.default.colors.errorLight,
            },
        },
        active: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5),
            '& svg': {
                color: theme_1.default.colors.primaryLight,
            },
        },
        alertActive: {
            backgroundColor: theme_1.default.colors.errorLight,
        },
        hoverMask: {
            position: 'absolute',
            left: -4,
            top: -4,
            width: 'calc(100% + 8px)',
            height: 'calc(100% + 8px)',
        },
    });
});
